module.exports = __webpack_public_path__ + "static/img/home_productcard_redmud.fc9ef9c8.jpg";